import { useOutletContext } from 'react-router'
import { Button } from '~/components/ui'
import { MapOutletContextData } from '~/hooks/map'
import useHasVisibleScrollBar from '~/hooks/map/useHasVisiableScrollBar'
import { cn } from '~/lib'
import MapListingCard from '../_map/components/listing-card'
import MapListingCardSkeleton from '../_map/components/listing-card-skeleton'

export default function MapCardsRoute() {
  const {
    listings,
    isError,
    isLoading,
    isFetching,
    fetchNextPage,
    hasNextPage,
  }: MapOutletContextData = useOutletContext()
  const data = useOutletContext<MapOutletContextData>()
  const hasVisibleScrollBar = useHasVisibleScrollBar()

  return (
    <div
      id="map-cards-list"
      className={cn(
        'absolute bottom-0 left-0 right-0 top-16 z-30 grid place-content-start gap-4 overflow-auto pb-4 sm:top-18',
        '3xl:grid-cols-5 grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-3 2xl:grid-cols-4',
        hasVisibleScrollBar ? 'pl-2 pr-0 sm:pl-4' : 'px-2 sm:px-4'
      )}>
      {isLoading
        ? Array.from({ length: 50 }, (value, index) => index).map((index) => {
            return (
              <MapListingCardSkeleton
                key={index}
                // className="2xl:w-72 md:w-72"
              />
            )
          })
        : listings.map((listing) => {
            return (
              <MapListingCard
                key={listing._id}
                className={cn(
                  isFetching && 'animate-pulse'
                  // 'cursor-default'
                )}
                listing={listing}
              />
            )
          })}
      {hasNextPage && (
        <div className="col-span-full flex justify-center">
          <Button disabled={isFetching} onClick={() => fetchNextPage()}>
            {isFetching ? 'Loading' : 'Load More'}
          </Button>
        </div>
      )}
    </div>
  )
}
